import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'dateUtil'
})
export class DateutilpipePipe implements PipeTransform {

    transform(value: Date | string | number | (number[]) | null | undefined): string {
        if (!value) return '';

        let date: Date | null = null;

        if (value instanceof Date) {
            date = value;
        } else if (typeof value === 'number') {
            date = new Date(value);
        } else if (typeof value === 'string') {
            date = this.parseStringDate(value);
        } else if (Array.isArray(value) && value.length === 3 && value.every(v => typeof v === 'number')) {
            const [year, month, day] = value;
            date = new Date(year, month - 1, day);
        }

        if (!date || isNaN(date.getTime())) return '';

        const yyyy = date.getFullYear();
        const mm = ('0' + (date.getMonth() + 1)).slice(-2);
        const dd = ('0' + date.getDate()).slice(-2);
        const hh = ('0' + date.getHours()).slice(-2);
        const min = ('0' + date.getMinutes()).slice(-2);

        if (hh !== '00' || min !== '00') {
            return `${yyyy}.${mm}.${dd} ${hh}:${min}`;
        }

        return `${yyyy}.${mm}.${dd}`;
    }

    private parseStringDate(value: string): Date | null {
        // Normalize to ensure iPhone Safari compatibility (replace space with T)
        const normalizedValue = value.replace(' ', 'T');

        // Try ISO/LocalDateTime first
        const isoDate = new Date(value);
        if (!isNaN(isoDate.getTime())) {
            return isoDate;
        }

        // dd-mm-yyyy or dd/mm/yyyy
        const dmyMatch = value.match(/^(\d{2})[-\/](\d{2})[-\/](\d{4})$/);
        if (dmyMatch) {
            const [, dd, mm, yyyy] = dmyMatch;
            return new Date(parseInt(yyyy), parseInt(mm) - 1, parseInt(dd));
        }

        // yyyy.mm.dd
        const ymdDots = value.match(/^(\d{4})[.](\d{2})[.](\d{2})$/);
        if (ymdDots) {
            const [, yyyy, mm, dd] = ymdDots;
            return new Date(parseInt(yyyy), parseInt(mm) - 1, parseInt(dd));
        }

        // yyyyMMdd without delimiters
        if (/^\d{8}$/.test(value)) {
            const yyyy = value.substring(0, 4);
            const mm = value.substring(4, 6);
            const dd = value.substring(6, 8);
            return new Date(parseInt(yyyy), parseInt(mm) - 1, parseInt(dd));
        }

        return null;
    }
}
